import { Box, Flex } from '@chakra-ui/react';
import { IntroPage } from '../introduction/introduction';
import { PeoplePage } from '../people/people';
import { AboutPage } from '../about/about';
import { PhilosphyPage } from '../philosophy/philosophy';
import { Footer } from '../general/footer';

export const HomePage = () => {
  return (
    <Flex direction={{ base: 'column', md: 'row' }} minH="100vh">
      <Box
        w={{ base: '100%', md: '50%' }}
        p={4}
        overflow="hidden"
        maxH={{ md: '100vh' }}
        bg="#eaeaea"
      >
        <IntroPage />
      </Box>

      <Box
        w={{ base: '100%', md: '50%' }}
        overflowY={{ md: 'auto' }}
        maxH={{ md: '100vh' }}
      >
        <PeoplePage />
        <AboutPage />
        <PhilosphyPage />
        <Footer />
      </Box>
    </Flex>
  );
};
